import { useQuery } from '@tanstack/react-query';
import { CompaniesFiltersDto, getCompaniesList } from '../directoryService';

export const QUERY_KEY = (filters) => ['GET_COMPANIES_LIST', filters];

export const useCompaniesList = (filters: CompaniesFiltersDto) => {
  const query = useQuery(QUERY_KEY(filters), () => getCompaniesList(filters));

  return query;
};
